import React from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend
);

const AssetAllocationChart = React.forwardRef(({ data }, ref) => {
    if (!data) return null;

    // Asset class color mapping from Retirement App
    const assetClassColors = {
        'Global Alpha': '#BBCBD7',              // Light grey-blue
        'Australian Equities': '#011E41',       // Very dark blue
        'International Equities': '#5E819C',    // Slate blue
        'Real Estate': '#A6C6C1',               // Pale teal
        'Infrastructure': '#337B91',            // Teal
        'Cash': '#EFE6D5',                      // Light beige
        'Government Bonds': '#F3BD48',          // Yellow/gold
        'Corporate Debt': '#AA8090',            // Dusty pink
        'Private Debt': '#874564',              // Dark burgundy
        'Private Equity': '#6C757D',            // Grey
        'Real Assets (Private Market)': '#127080' // Dark teal
    };

    const labels = Object.keys(data);
    const values = Object.values(data).map(v => v * 100);
    const backgroundColors = labels.map(label => assetClassColors[label] || '#808080');

    const chartData = {
        labels,
        datasets: [
            {
                data: values,
                backgroundColor: backgroundColors,
                borderColor: backgroundColors.map(color => color + 'CC'),
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    padding: 10,
                    usePointStyle: true,
                    font: {
                        size: 11
                    }
                }
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return context.label + ': ' + context.parsed.toFixed(1) + '%';
                    },
                },
            },
        },
    };

    return <Pie ref={ref} data={chartData} options={options} />;
});

export default AssetAllocationChart;
